import videoSources from 'shared/constants/video-sources';

/*import { detect } from 'shared/utils/device/detection';*/


export function canStartPlaybackInFullScreen(videoItem) {
  const { videoSource } = videoItem;

  return videoSource === videoSources.COMPUTER;
}



// WEBPACK FOOTER //
// ./src/widget/utils/player.js